export const countdownRenderer = ({ hours, minutes, seconds, completed }) => {
	if (completed) {
		// Render a completed state
		return <>00:00</>
	} else {
		// Render a countdown
		return (
			<span>
				{String(minutes).padStart(2, '0')}:
				{String(seconds).padStart(2, '0')}
			</span>
		)
	}
}
